var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from "axios";
import SnackbarUtil from "da-ged-web/utils/SnackbarUtil";
import axiosCatchError from "./AxiosCatchErrorImplement";
import gedMiddlewareEndpoint from "./gedMiddlewareEndpoint";
var i18n = { t: function (m) { return m; } };
var sizes = [300, 600, 1000, 1400, 1600, 2000];
var FileService = /** @class */ (function () {
    function FileService() {
    }
    var _a;
    _a = FileService;
    FileService.createFile = function (_b, options) {
        var file = _b.file, _c = _b.nodeId, nodeId = _c === void 0 ? undefined : _c;
        if (options === void 0) { options = {}; }
        var formData = new FormData();
        formData.append("file", file);
        return axios
            .post("".concat(gedMiddlewareEndpoint, "/").concat(nodeId ? "/folders/".concat(nodeId) : "", "/files"), formData, options)
            .catch(function (error) {
            var customError = axiosCatchError(error);
            var message = "";
            if (customError.error === "file.mimetype.not.allowed") {
                message = "Erreur, le format du fichier n'est pas pris en charge";
            }
            else {
                message = "Erreur lors du téléversement du fichier";
            }
            throw new Error(message);
        });
    };
    FileService.getPreview = function (nodeId) {
        return axios
            .get("".concat(gedMiddlewareEndpoint, "/files/").concat(nodeId, "/preview"), {
            responseType: "blob" // Force to receive data in a Blob Format
        })
            .catch(function (error) { return axiosCatchError(error); });
    };
    FileService.deleteFile = function (nodeId) {
        return axios.delete("".concat(gedMiddlewareEndpoint, "/files/").concat(nodeId)).catch(function (error) { return axiosCatchError(error); });
    };
    FileService.trulyDeleteFile = function (nodeId) {
        return axios.delete("".concat(gedMiddlewareEndpoint, "/trash/files/").concat(nodeId)).catch(function (error) { return axiosCatchError(error); });
    };
    FileService.renameFile = function (_b) {
        var fileId = _b.fileId, name = _b.name;
        return axios
            .patch("".concat(gedMiddlewareEndpoint, "/files/").concat(fileId), {
            name: name
        })
            .then(function (response) {
            if (response) {
                SnackbarUtil.setSnackbar({
                    status: "success",
                    message: i18n.t("Node renamed")
                });
            }
        })
            .catch(function (error) {
            var customError = axiosCatchError(error);
            if (customError.error === "name.already.exist") {
                throw new Error(i18n.t("File exist"));
            }
            else {
                SnackbarUtil.setSnackbar({
                    status: "error",
                    message: i18n.t("Node renamed error")
                });
                throw new Error();
            }
        });
    };
    FileService.downloadFile = function (fileId) {
        return axios
            .get("".concat(gedMiddlewareEndpoint, "/files/").concat(fileId, "?alt=media"), {
            responseType: "blob" // Force to receive data in a Blob Format
        })
            .then(function (response) {
            return response.data;
        })
            .catch(function (error) { return axiosCatchError(error); });
    };
    FileService.moveFile = function (_b) {
        var fileId = _b.fileId, parent = _b.parent, message = _b.message;
        return axios
            .patch("".concat(gedMiddlewareEndpoint, "/files/").concat(fileId), {
            parentId: (parent === null || parent === void 0 ? void 0 : parent.id) || null
        })
            .then(function (response) {
            if (response) {
                SnackbarUtil.setSnackbar({
                    status: "success",
                    message: message
                });
            }
        })
            .catch(function (error) {
            var moveError = axiosCatchError(error);
            if (moveError && moveError.error === "folder.not.found") {
                throw new Error(i18n.t("Folder not found"));
            }
            else if (moveError && moveError.error === "name.already.exist") {
                throw new Error(i18n.t("File isn't move"));
            }
            else {
                SnackbarUtil.setSnackbar({
                    status: "error",
                    message: i18n.t("File operation impossible")
                });
                throw new Error();
            }
        });
    };
    FileService.duplicateFile = function (_b) {
        var fileId = _b.fileId, fileName = _b.fileName;
        return axios
            .post("".concat(gedMiddlewareEndpoint, "/files/").concat(fileId, "/copy"), {
            name: i18n.t("Copy of") + fileName
        })
            .catch(function (error) { return axiosCatchError(error); });
    };
    FileService.restoreFile = function (nodeId) {
        return new Promise(function (resolve) { return __awaiter(void 0, void 0, void 0, function () {
            var error_1;
            return __generator(_a, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios.patch("".concat(gedMiddlewareEndpoint, "/trash/files/").concat(nodeId), {
                                deleted: false
                            })];
                    case 1:
                        _b.sent();
                        resolve(true);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _b.sent();
                        resolve(false);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); });
    };
    FileService.publish = function (_b) {
        var file = _b.file, pageVersion = _b.pageVersion;
        var fileId = file.id;
        var _c = pageVersion || {}, pageVersionId = _c.id, _d = _c.page, page = _d === void 0 ? {} : _d;
        var _e = (pageVersion || {}).pageId, pageId = _e === void 0 ? page.id : _e;
        var publicPath = "/tmp";
        if (pageVersionId && pageId) {
            publicPath = "/".concat(pageId, "/").concat(pageVersionId);
        }
        return axios
            .post("".concat(gedMiddlewareEndpoint, "/files/").concat(fileId, "/publish"), {
            publicPath: publicPath,
            size: sizes
        })
            .catch(function (error) { return axiosCatchError(error); });
    };
    return FileService;
}());
export default FileService;
